module.exports = __webpack_public_path__ + "static/media/student2.480ef4bd.png";